function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M9 0a9 9 0 109 9 9 9 0 00-9-9z",
  fillRule: "evenodd",
  fill: "#68b7e6"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.553 4.181a.743.743 0 00-.947.228l-4.565 6.872-2.712-2.945a.753.753 0 00-.957-.1.6.6 0 00-.192.823l.027.04 3.367 4.6a.722.722 0 00.584.285h.033a.711.711 0 00.586-.337l5.05-8.613a.609.609 0 00-.227-.828z",
  fill: "#fff",
  fillRule: "evenodd"
});

var SvgNavCircleActive = function SvgNavCircleActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18
  }, props), _ref, _ref2);
};

export default SvgNavCircleActive;